'use strict';

const Mn = require('backbone.marionette');
const OriginalDiagramItemView = require('system/ui/view/diagram/item');
const OriginalDiagramDirectoryView = require('system/ui/view/diagram/directory');
const DiagramListView = require('system/ui/view/diagram/list');
const ItemTemplate = require('balus/ui/template/body/process/toolbar/diagram-item.hbs');
const DirectoryTemplate = require('balus/ui/template/diagram/directory.hbs');
const Template = require('balus/ui/template/diagram/list.hbs');

const DiagramDirectoryView = OriginalDiagramDirectoryView.extend({
    template: DirectoryTemplate,
    childViewTriggers: {
        'active': 'active',
        'inactive': 'inactive',
    }
});

const DiagramItemView = OriginalDiagramItemView.extend({
    showItemLink: false,
    template: ItemTemplate,
    className: 'list-item',
    events: {
        'change': 'select'
    },

    onAttach: function() {
        $.material.init();
    },

    select: function() {
        this.$el.toggleClass('is-active');
        if(this.$el.hasClass('is-active')) {
            this.triggerMethod('active', this.model);
        } else {
            this.triggerMethod('inactive', this.model);
        }
    }
});

module.exports = DiagramListView.extend({
    template: Template,
    childView: function(child){
        if(child.get('directory')) {
            return DiagramDirectoryView;
        }
        else {
            return DiagramItemView;
        }
    },

    onChildviewActive: function(diagram) {
        if(!this._activeDiagrams) {
            this._activeDiagrams = {};
        }
        this._activeDiagrams[diagram.id] = diagram;
        this.trigger('select:diagram');
    },

    onChildviewInactive: function(diagram) {
        delete this._activeDiagrams[diagram.id];
        this.trigger('select:diagram');
    },

    getActiveDiagrams: function() {
        return _.keys(this._activeDiagrams);
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/process/toolbar/diagram-list.js